/**
 * @file   : ContactUsCardBack.js
 * @author : Amarjeet Lamba (Amarjeet.Lamba@AspiraConnect.com)
 * @date   : 2/4/2019, 6:33:59 PM
 */
import PropTypes from 'prop-types'
import React from 'react'

import Cont from '../../../external/components/layout/Cont'
import ABaseLink from '../../../external/components/link/ABaseLink'
import TextStyler, {
  DARK_BLUE_TEXT,
  FONT_WEIGHT,
} from '../../../external/components/text/TextStyler'
import { isEmpty, isUndefined } from '../../../external/utilities/GeneralUtils'
import { simpleTranslate } from '../../Translation'
import { CHANNEL_WEB } from '../ContactUsContainer'

const ContactUsCardBack = ({
  intl,
  client = {},
  onSelectClientChannelRequest,
}) => {
  const getBoldText = function (label = '') {
    return (
      <TextStyler
        styleObj={{
          ...DARK_BLUE_TEXT,
          fontWeight: FONT_WEIGHT.BOLD,
        }}
      >
        {label}
      </TextStyler>
    )
  }

  const getClientInfoSectionUI = function () {
    return getBoldText(client.name)
  }

  const getChannelSectionUI = function () {
    let channelsUI = null

    if (
      !isEmpty(client) &&
      !isUndefined(client.contactChannels) &&
      !isEmpty(client.contactChannels)
    ) {
      channelsUI = client.contactChannels.map((channel, i) => {
        let identifierUI = null
        let typeUI = null
        if (channel.type === CHANNEL_WEB) {
          typeUI = (
            <ABaseLink to={channel.identifier} internal={false} newWin>
              {simpleTranslate(
                intl,
                `contact_us_channel_${channel.type}`,
                channel.type,
              )}
            </ABaseLink>
          )
        } else {
          typeUI = getBoldText(
            simpleTranslate(
              intl,
              `contact_us_channel_${channel.type}`,
              channel.type,
            ),
          )
          identifierUI = (
            <ABaseLink
              onClick={() => {
                onSelectClientChannelRequest(client, channel)
              }}
            >
              {channel.identifier}
            </ABaseLink>
          )
        }

        return (
          <Cont key={i}>
            {typeUI}
            {identifierUI}
          </Cont>
        )
      })
    }

    return <Cont>{channelsUI}</Cont>
  }

  return (
    <Cont className="contact-card-container">
      <Cont className="contact-card-top-section contact-title">
        {getClientInfoSectionUI()}
      </Cont>
      <Cont className="contact-card-bottom-section">
        {getChannelSectionUI()}
      </Cont>
    </Cont>
  )
}

ContactUsCardBack.propTypes = {
  intl: PropTypes.object.isRequired,
  client: PropTypes.object.isRequired,
  onSelectClientChannelRequest: PropTypes.func.isRequired,
}

export default ContactUsCardBack
